import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";

function VisitingDoctors() {
    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <h1>Specialist Consultations</h1>
            <p className="caboutus">
            Specialist Consultations visits are scheduled on a weekly basis. The detailed schedule is listed below for your reference:
            </p>
            
            <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                    <td>
                                    <strong>S.No.</strong>
                                    </td>
                                    <td>
                                    <strong>DOCTOR’S NAME </strong>
                                    </td>
                                    <td>
                                    <strong>SPECIALITY </strong>
                                    </td>
                                    <td>
                                    <strong>DAY OF VISIT </strong>
                                    </td>
                                    <td>
                                    <strong>TIMINGS </strong>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    1.
                                    </td>
                                    <td>
                                    Dr. Arun Kumar                                  
                                    </td>
                                    <td>
                                   Ophthalmologist                                  
                                    </td>
                                    <td>
                                    Tuesday                                  
                                    </td>
                                    <td>
                                    4 PM to 5 PM                                 
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    2.
                                    </td>
                                    <td>
                                    Dr. Sahithi                                  
                                    </td>
                                    <td>
                                    Dentist                                  
                                    </td>
                                    <td>
                                    Wednesday                                  
                                    </td>
                                    <td>
                                    5 PM to 6 PM                                 
                                    </td>
                                    </tr>
                                    
                                    <tr>
                                    <td>
                                    3.
                                    </td>
                                    <td>
                                    Dr. Sindhura                                  
                                    </td>
                                    <td>
                                    Paediatrician                                   
                                    </td>
                                    <td>
                                    Thursday                                  
                                    </td>
                                    <td>
                                    5 PM to 6 PM                                 
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    4.
                                    </td>
                                    <td>
                                    Dr. Keerthi                                  
                                    </td>
                                    <td>
                                    Dermatologist                                 
                                    </td>
                                    <td>
                                    Thursday                                  
                                    </td>
                                    <td>
                                    5 PM to 6 PM                                  
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    5.
                                    </td>
                                    <td>
                                    Dr. Umamaheswar                                  
                                    </td>
                                    <td>
                                    Orthopaedics                                  
                                    </td>
                                    <td>
                                    Friday                                  
                                    </td>
                                    <td>
                                    4.30 PM to
                                    5.30 PM                                  
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    6.
                                    </td>
                                    <td>
                                    Dr. Pratap                                  
                                    </td>
                                    <td>
                                    E.N.T                                 
                                    </td>
                                    <td>
                                    Friday                                  
                                    </td>
                                    <td>
                                    4.30 PM to
                                    5.30 PM                                  
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    7.
                                    </td>
                                    <td>
                                    Dr. Madhu Azad                                  
                                    </td>
                                    <td>
                                    Homeopathy                                 
                                    </td>
                                    <td>
                                    Saturday                                  
                                    </td>
                                    <td>
                                    10 AM to 11 AM                                  
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    8.
                                    </td>
                                    <td>
                                    Dr. Kishore Kumar                                  
                                    </td>
                                    <td>
                                    Psychiatrist                                  
                                    </td>
                                    <td>
                                    Every 2nd & 4th Saturday                                  
                                    </td>
                                    <td>
                                    4 PM to 5PM                                 
                                    </td>
                                    </tr>
                                    
                                    </tbody>
                                </table>

                                <h5 className="text-teal m-4 mb-4">Kindly note that, there will be no prior appointments required.</h5>

                                <h5 className="text-teal m-4 mb-4">If there are any schedule changes in the specialist visit, the Health Centre will notify you as soon as possible.</h5> 
                                
            
        </div>
    );
}

export default VisitingDoctors;
